module.exports = __webpack_public_path__ + "media/images/fbcalls/gold_to_blue_transition-e6eef0c1d4dea358c93908a8e73e774f.jpg";